import { createContext } from "react";

const ExecutiveFilterSearchContext = createContext(null);

export default ExecutiveFilterSearchContext;
